<template>
    <div class="spinner-container">
        <div class="spinner">
            <div class="spinner__image"></div>
            <div class="spinner__loading-bar">
                <div
                    v-for="loadingBar in loadingBars"
                    :key="loadingBar.key"
                    v-html="loadingBar.el"
                ></div>
            </div>
            <div class="spinner__loading-percentage">
                {{ percentage }}%
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
export default Vue.extend({
    props: {
        percentage: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            loadingBars: [],
        };
    },
    beforeMount() {
        this.drawLoadingBars();
    },
    beforeUpdate() {
        this.drawLoadingBars();
    },
    methods: {
        drawLoadingBars: function() {
            this.loadingBars = [];
            const percentageBreakpoint = Math.floor(this.percentage / 5) + 1;
            for (let i = 1; i <= 20; i++) {
                let percentageClass = 'spinner__loading-bar-line ';
                if (i <= percentageBreakpoint) {
                    if (i === percentageBreakpoint) {
                        percentageClass =
                            percentageClass +
                            'line' +
                            (i % percentageBreakpoint);
                    } else {
                        percentageClass =
                            percentageClass +
                            'line' +
                            (percentageBreakpoint - (i % percentageBreakpoint));
                    }
                }
                this.loadingBars.push({
                    el: `<div class="${percentageClass}"></div>`,
                    key: i,
                });
            }
        },
    },
});
</script>

<style lang="scss">
@import './LoadingScreen';
</style>
